import { Slot } from "@radix-ui/react-slot";
import { type VariantProps } from "tailwind-variants";

import { TPolymorphicComponentProps } from "@/types";

import { textVariants } from "./variants";

type TextProps = React.HTMLAttributes<HTMLElement> &
  TPolymorphicComponentProps &
  VariantProps<typeof textVariants>;

const Text = (props: TextProps) => {
  const {
    children,
    asChild,
    dataTestId,
    className,
    anchor,
    animateIn,
    animateOut,
    caret,
    size,
    ...rest
  } = props;

  const Comp = asChild ? Slot : "span";

  return (
    <Comp
      data-testid={dataTestId}
      data-i2-child="text"
      className={textVariants({
        anchor,
        animateIn,
        animateOut,
        caret,
        size,
        className,
      })}
      {...rest}
    >
      {children}
    </Comp>
  );
};

Text.displayName = "Text";

export { Text, textVariants };
